import { render, staticRenderFns } from "./ButtonV3.vue?vue&type=template&id=10407be3&scoped=true&"
import script from "./ButtonV3.vue?vue&type=script&lang=js&"
export * from "./ButtonV3.vue?vue&type=script&lang=js&"
import style0 from "./ButtonV3.vue?vue&type=style&index=0&id=10407be3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10407be3",
  null
  
)

export default component.exports